
















import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class gtFormItemTip extends Vue {
  @Prop() content: String;
  @Prop({ default: "hover" }) trigger: String;
  @Prop({ default: "top-start" }) placement: String;
  @Prop({ default: "350" }) width: String;
  @Prop({ default: "help" }) icon: String;
  @Prop() label: String;
}
